import { KeyValue } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'keyValueArrayFilter',
})
export class KeyValueArrayFilterPipe implements PipeTransform {
  transform(value: KeyValue<string, unknown>[], yourKey: string): KeyValue<string, unknown> | null {
    let result = null;

    if (value) {
      result = value.find((v) => v.key === yourKey);
    }

    return result || null;
  }
}
